import React from 'react'
import CIcon from '@coreui/icons-react'
import {
  cilContact,
  cilShieldAlt,
  cilGroup,
  cilPuzzle,
  cilSpeedometer,
  cilGift,
  cibOpenAccess,
  cilBook,
  cilAudio,
  cilLink,
} from '@coreui/icons'
import { CNavItem } from '@coreui/react'

const _nav = [
  {
    component: CNavItem,
    name: 'Thống kê',
    to: '/thong-ke',
    icon: <CIcon icon={cilSpeedometer} customClassName="nav-icon" />,
  },
  {
    component: CNavItem,
    name: 'Danh mục',
    to: '/danh-muc',
    icon: <CIcon icon={cilBook} customClassName="nav-icon" />,
  },
  {
    component: CNavItem,
    name: 'Sản phẩm',
    to: '/san-pham',
    icon: <CIcon icon={cilGift} customClassName="nav-icon" />,
  },
  {
    component: CNavItem,
    name: 'Khách hàng',
    to: '/khach-hang',
    icon: <CIcon icon={cilGroup} customClassName="nav-icon" />,
  },
  {
    component: CNavItem,
    name: 'Kích hoạt',
    to: '/kich-hoat',
    icon: <CIcon icon={cibOpenAccess} customClassName="nav-icon" />,
  },
  {
    component: CNavItem,
    name: 'Bảo hành',
    to: '/bao-hanh',
    icon: <CIcon icon={cilShieldAlt} customClassName="nav-icon" />,
  },
  {
    component: CNavItem,
    name: 'Đại lý',
    to: '/dai-ly',
    icon: <CIcon icon={cilPuzzle} customClassName="nav-icon" />,
  },
  {
    component: CNavItem,
    name: 'Tin tức',
    to: '/tin-tuc',
    icon: <CIcon icon={cilAudio} customClassName="nav-icon" />,
  },
  {
    component: CNavItem,
    name: 'Link sản phẩm',
    to: '/link-san-pham',
    icon: <CIcon icon={cilLink} customClassName="nav-icon" />,
  },
  {
    component: CNavItem,
    name: 'Tài khoản',
    to: '/tai-khoan',
    icon: <CIcon icon={cilContact} customClassName="nav-icon" />,
  },
]

export default _nav
